<template>
    <auth-layout>
        <Head>
            <title>Passwort vergessen</title>
        </Head>

        <div class="auth-form">
            <div class="auth-form--form">
                <h3>
                    <h3 v-translate>Passwort vergessen?</h3>
                </h3>
                <p class="body-1">
                    <translate render-html="true">Wir haben Ihnen eine Email zum zurücksetzen Ihres Passwortes zugesendet.
                    </translate>
                </p>
            </div>
            <div class="auth-form--info">
                <p class="body-2 body-2--disabled">
                    <translate render-html="true">Es können ausschließlich <strong>registrierte Geschäftskunden</strong> beliefert werden.
                        An Privatpersonen liefern wir nicht aus! Ihre Daten werden nur für Ihre Anfragen und Aufträge
                        genutzt, nicht an Dritte weitergeleitet, nicht für Werbezwecke verwendet. Das garantieren wir Ihnen.
                        Ihre Kundendaten handhaben wir streng vertraulich, gemäß den Datenschutzbestimmungen der
                        Bundesrepublik Deutschland.
                    </translate>
                </p>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@partfactory/Layouts/AuthLayout';

export default {
    name: 'ForgotPasswordConfirmation',
    components: {
        AuthLayout,
    },
};
</script>
